module.exports = __webpack_public_path__ + "static/media/pycerti.5a87787a.jpg";